import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
export var useGetTranslations = function useGetTranslations() {
  var _useNuxt2App = useNuxt2App(),
    i18n = _useNuxt2App.i18n;
  return {
    /**
     * Translate the given key
     *
     * @param      {string}  key         The key
     * @param      {any}  other?:any  The other any
     * @return     {string}  The translated message
     * @deprecated Use i18n instead
     */
    translate: function translate(key, other) {
      return i18n.t(key, other).toString();
    }
  };
};